import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { StatusLoadingComponent } from './status-loading.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [StatusLoadingComponent],
  exports: [StatusLoadingComponent]
})
export class StatusLoadingModule {
}
